import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth-service.service';
import {MatDialog} from '@angular/material/dialog';
import { TermsAndConditionssPageComponent } from 'src/app/shared/terms-and-conditionss-page/terms-and-conditionss-page.component';
import { ContactUsComponent } from 'src/app/shared/contact-us/contact-us.component';
 import { interval, Subscription } from 'rxjs';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-standalone-header',
  templateUrl: './standalone-header.component.html',
  styleUrls: ['./standalone-header.component.css']
})
export class StandaloneHeaderComponent implements OnInit,OnDestroy {
  userName: string;
  accountNo: string;
  imgsrc: any;
  notifCount: any;
  commentsList = false;
  nameCahngeSubscription: Subscription;
  unreadMessageSubscrition: Subscription;
  kycStatusSubscrition:Subscription;
  intervalId:any;
  messagebizId='';
  biz='';
  bizId='';
  business = '';
  businessList = [];
  messageBusinessList = [];
  kycStatus=0;
  is_idme_verified = false;

      constructor(public _api: ApiService
    , private _utils: UtilitiesService
    , private sanitizer: DomSanitizer
    , public router: Router
    , private _utilityService: UtilitiesService
    , private authService: AuthService
    , private dialog: MatDialog) { 
      this.messagebizId = null;
      this.business = null;
      window.addEventListener('beforeunload', () => {
        this.messagebizId = null;
        this.business = null;
      });
      this.router.events.subscribe((val) => {
        if (val instanceof NavigationEnd) {
           if(val.url === '/current_business/auth-message'){
            this.commentsList=true;
          }else{
            this.commentsList=false;
          }
        }
      });
    }

    createOnlineSub:Subscription;

  ngOnInit() {
    this._utils.profilepic.subscribe((event) => {
      this.getProfilePhoto();
    });
    this._utils.message.subscribe((event) => {
      this.getNotifcount();
    });
     this.getSupportedDocumentType();
    this.nameCahngeSubscription = this._utilityService.nameChange.subscribe((event) => {
      this.getUserData();
    });
    this.isValidToken();
     this.getSupportedUploadTypes(); 
    this.getUserData();
    this.getBizList();
    window.addEventListener('focus', this.onStartCount);    
    window.addEventListener('blur', this.onStopCount);
  } 
  private onStartCount = () => {
    this.intervalId = setInterval((()=>{
      if (!this.messagebizId) {
   return;
 } 
 this.createOnlineSub = this._api.createOnline$().subscribe((status) => {
   if (status) {
    if(this.messagebizId){
      const data = {
        bp_business_id: this.messagebizId
      };
      this._api.functionPOST('message/getMessageUnreadCount', data).subscribe((response) => {
        this._api.messageCount = response.data;
         this._utilityService.changeMessageBusinessID(this.messagebizId);
      });

      this._api.functionPOST('task/getPendingTaskCount',  { current_bp_business_id: this.messagebizId}).subscribe((response) => {
        this._api.taskCount = response.data;
      });

    }
    
   }
 })
 }), 60000); 
  }
  private onStopCount = () => {
    window.clearInterval(this.intervalId);
  }
  pendingNotification(){
    this.kycStatus = 1;
  }
  isValidToken() {
    this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
       if (res['data']['is_approved_once']=='N') {
        this.kycStatus = 2;
      }
      this.is_idme_verified=res['data']['idme_verified'];
    })
  }
  
  ngOnDestroy() {
    this.messagebizId = null;
    this.business = null;
    if (this.createOnlineSub) {
      this.createOnlineSub.unsubscribe();
    }
        if(this.unreadMessageSubscrition){
      this.unreadMessageSubscrition && this.unreadMessageSubscrition.unsubscribe();
      clearInterval(this.intervalId);
     }
  }
  getMessageUnreadCount():any{
    if(!this.messagebizId){
      return;
    }
    this.createOnlineSub = this._api.createOnline$().subscribe((status) => {
      if(status){
        if(this.messagebizId){
          const data = {
            bp_business_id: this.messagebizId
          };
          this._api.functionPOST('message/getMessageUnreadCount', data).subscribe((response) => {
             this._api.messageCount = response.data;
             this._utilityService.changeMessageBusinessID(this.messagebizId);
          });
          this._api.functionPOST('task/getPendingTaskCount', { current_bp_business_id: this.messagebizId}).subscribe((response) => {
            this._api.taskCount = response.data;
          });
        }
      }})
  }
 
  getProfilePhoto() {
    this._api.fileReader('user/getUserImage', '').subscribe((response) => {
      this.imgsrc = this._utils.getImageURL(response);
     }, err => {

    });
  }
  createImage(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const url = reader.result;
      this.imgsrc = this.sanitizer.bypassSecurityTrustUrl(url as any);
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getUserData() {
    // const data = {
    //   user_id: this.cookieService.get('user_id'),
    // };
     this._api.functionPOST('user/getUserDetailsById', {}).subscribe((res) => {
       const userdetails = res['data']['userData'];
      sessionStorage.setItem('userEmail', userdetails['email']);
      const firstname = userdetails.firstname;
      const middlename = userdetails.middlename ? userdetails.middlename : '';
      const lastname = userdetails.lastname;
      this.userName = firstname + ' ' + middlename + ' ' + lastname;
      this._utils.creatorID = userdetails.um_user_id;
      this.accountNo = res['data']['userData'].account_id;
    });
  }
  logOut() {
    this.messagebizId = null;
    this.business = null;
    this._api.functionPOST('user/logout', {}).subscribe((res) => {
      this.authService.logout();
    });
  }
  contactUs(): void {
    const dialogRef = this.dialog.open(ContactUsComponent, { width: '350px', data: '' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  Terms(): void {
    const dialogRef = this.dialog.open(TermsAndConditionssPageComponent, { panelClass: 'min-w-tc', data: '' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  getNotifcount() {
    this._api.functionPOST('user/getNewNotificationAlertCount', '').subscribe((response) => {
      this.notifCount = response['data']['new_messages']; 
    });
  }

  getSupportedDocumentType() {
    this._api.functionGET('files/getSupportedProfileImageDetails').subscribe(res => {
      this._utilityService.getDocType(res.data); 
    });
  }

  getSupportedUploadTypes() {
    this._api.functionGET('files/getSupportedFileDetails').subscribe(res => {
      this._utilityService.getUploadTypes(res.data);
    });
  }

  getBizList(){
    this._api.functionPOST('user/getUserEditableBusinesses', {}).subscribe((response) => {
     this.messageBusinessList = response['data'];
      if(this.messageBusinessList.length>0){
        this.messagebizId = this.messageBusinessList[0].bp_business_id;
     }
      this.getMessageUnreadCount();
     });
 }
setBiz($event) {
  this.bizId = $event.value;
   this._utilityService.changeMessageBusinessID($event.value);
  if ( this.businessList.findIndex((x) => x.bp_business_id === $event.value) >= 0) {
    this.business = $event.value;
    this._utilityService.changeBusinessID($event.value);
    // this.setPreference($event);
  }
}
navClick(){
  this.router.navigate(['/current_business']);
}

backToCurrentBuisness() {
  const stateData = { tab: 3};
    this.router.navigate(['/current_business'], { state: stateData });
}

}
